// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  'Adjectival Noun': (t, data?, options?) => t('enum.part-of-speech.adjectival-noun.name', data, options),
  Adjective: (t, data?, options?) => t('enum.part-of-speech.adjective.name', data, options),
  Adverb: (t, data?, options?) => t('enum.part-of-speech.adverb.name', data, options),
  'Auxiliary Verb': (t, data?, options?) => t('enum.part-of-speech.auxiliary-verb.name', data, options),
  Conjunction: (t, data?, options?) => t('enum.part-of-speech.conjunction.name', data, options),
  Determiner: (t, data?, options?) => t('enum.part-of-speech.determiner.name', data, options),
  Interjection: (t, data?, options?) => t('enum.part-of-speech.interjection.name', data, options),
  Interrogative: (t, data?, options?) => t('enum.part-of-speech.interrogative.name', data, options),
  Noun: (t, data?, options?) => t('enum.part-of-speech.noun.name', data, options),
  'Noun Abbreviation': (t, data?, options?) => t('enum.part-of-speech.noun-abbreviation.name', data, options),
  Particle: (t, data?, options?) => t('enum.part-of-speech.particle.name', data, options),
  'Phrasal Verb': (t, data?, options?) => t('enum.part-of-speech.phrasal-verb.name', data, options),
  Phrase: (t, data?, options?) => t('enum.part-of-speech.phrase.name', data, options),
  Preposition: (t, data?, options?) => t('enum.part-of-speech.preposition.name', data, options),
  Pronoun: (t, data?, options?) => t('enum.part-of-speech.pronoun.name', data, options),
  'Proper Noun': (t, data?, options?) => t('enum.part-of-speech.proper-noun.name', data, options),
  Verb: (t, data?, options?) => t('enum.part-of-speech.verb.name', data, options),
  'Verbal Noun': (t, data?, options?) => t('enum.part-of-speech.verbal-noun.name', data, options),
  /* eslint-enable max-len */
};
